import React, { useRef, useState, useEffect } from 'react'

import { Row, Col, Input } from 'reactstrap'

const ContBasicTableSearchBox = ({ onChange }) => {
  const [searchText, setSearchText] = useState(null)
  const delayRef = useRef()

  useEffect(() => {
    if (searchText !== null) {
      delayRef.current = setTimeout(() => onChange(searchText), 500)
      return () => clearTimeout(delayRef.current)
    }
  }, [searchText, onChange])

  return (
    <Row className='mb-2'>
      <Col md='12'>
        <Input
          onChange={e => setSearchText(e.target.value)}
          maxLength='50'
          placeholder='Buscar ...'
          type='text'
          bsSize='sm'
        />
      </Col>
    </Row>
  )
}

export default ContBasicTableSearchBox
